"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsNodeJs = useIsNodeJs;
const ExecutionEnvironmentUtils_1 = require("@gt/common-utils/build/general/ExecutionEnvironmentUtils");
function useIsNodeJs() {
    return ExecutionEnvironmentUtils_1.ExecutionEnvironmentUtils.isNode();
}
